import React from 'react'
import SuccessSvg from 'modules/react/signup/SuccessSvg'
import SignupContext from 'modules/react/signup/SignupContext'

export default function SignupCompleted () {

  const signupContext = React.useContext(SignupContext)
  const { modal } = signupContext

  React.useEffect(() => {
    modal?.addClass('signup-modal--smaller-form')

    return () => modal?.removeClass('signup-modal--smaller-form')
  }, [modal])

  return (
    <div className="signup-modal__content-full-width">
      <div className="title title--h3">Tak for din tilmelding!</div>
      <div className="wysiwyg">Du vil blive kontaktet når det er muligt at tilmelde sig kurset</div>
      <div className="image-wrap image-wrap--center">
        {SuccessSvg()}
      </div>
    </div>
  )
}